<app-view-title Title="{{ 'Intellitrailer.Booking.ChangeBooking.Title2' | translate : 'What would you like to change?' }}" mode="soft"></app-view-title>
<view-content [centered]="true" >
  @if(loading) {
  <div class="spinner-container">
    <mat-spinner class="spinner-container" diameter="70"></mat-spinner>
    <p>{{'Interllitrailer.ChangeBooking.txtLoadingMessage' | translate: 'Finding options...'}}</p>
  </div>
  }
  @else {
  <data-list>
    <list-item (click)="changeLocation()">
      <mat-icon>map</mat-icon>
      <div>{{ 'Intellitrailer.Booking.ChangeBooking.ChangeLocation' | translate : 'Change Location' }}</div>
    </list-item>
    <list-item (click)="changeType()">
      <mat-icon>rv_hookup</mat-icon>
      <div>{{ 'Intellitrailer.Booking.ChangeBooking.ChangeModel' | translate : 'Change Model' }}</div>
    </list-item>
    <list-item (click)="changeTime()">
      <mat-icon>calendar_today</mat-icon>
      <div>{{ 'Intellitrailer.Booking.ChangeBooking.ChangeTime' | translate : 'Change Time' }}</div>
    </list-item>
  </data-list>
  }


</view-content>
